import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=62fa24b4&scoped=true"
import script from "./Uploads.vue?vue&type=script&lang=js"
export * from "./Uploads.vue?vue&type=script&lang=js"
import style0 from "./Uploads.vue?vue&type=style&index=0&id=62fa24b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa24b4",
  null
  
)

export default component.exports